export default __webpack_public_path__ + "scene1_2_bgd5b5d5.png";